// extracted by mini-css-extract-plugin
module.exports = {"t1e31uhj":"t1e31uhj","full-bleed":"full-bleed"};